'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('membership', {
      url: '/membership',
      template: '<membership></membership>',
      authenticate: 'user',
      parent: 'terrapp'
    })

    // TODO: A new page for basket creation
    // 
    // .state('membershipBasket', {
    //   url: '/membership/baskets/:membershipId?/:seasonId?',
    //   template: '<membership-basket></membership-basket>',
    //   authenticate: 'user',
    //   parent: 'terrapp'
    // });
}



// WEBPACK FOOTER //
// ./client/app/membership/membership.routes.ts